// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__TeRUY","label":"Section_label__1YtFZ","contentWrap":"Section_contentWrap__1rJ6R","footer":"Section_footer__1D5pA","footerInner":"Section_footerInner__2dze0"};